export default __webpack_public_path__ + "static/media/logo-error.0afa5887.svg";